import { render, staticRenderFns } from "./AgentAnnuityPrice.vue?vue&type=template&id=056cc704&"
import script from "./AgentAnnuityPrice.vue?vue&type=script&lang=js&"
export * from "./AgentAnnuityPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports